import { environment } from "../../environments/environment";

export let production = environment.production;

export const stripePublishableKey = production ? "pk_live_u1yuWxH7hOhcrh0u49dHY3AL" : "pk_test_DiFFoHzXckoo8mADq9FPAbtN";
